import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { useTheme } from "@/components/ThemeContext";
import ScrollReveal from "@/components/ScrollReveal";

export default function CTASection() {
  const { isDark } = useTheme();

  return (
    <section data-testid="cta-section" className={`py-20 md:py-32 relative overflow-hidden transition-colors duration-500 ${isDark ? "bg-[#0E0E0E]" : "bg-[#1A1A1A]"}`}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#C9A646] rounded-full filter blur-[150px]" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <ScrollReveal>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-[#C9A646] block mb-6">Pronto a partire?</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-normal text-white mb-4">Viaggia con stile.</h2>
          <p className="text-lg md:text-xl text-[#C9A646] italic mb-10">Prenota ora il tuo transfer esclusivo.</p>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:+393784035054" data-testid="cta-call-btn" className="inline-flex items-center justify-center gap-2 bg-[#C9A646] text-[#0A0A0A] px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-[#E1C16E] transition-all duration-300 w-full sm:w-auto">
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              Chiama Subito
            </a>
            <Link to="/prenota" data-testid="cta-book-btn" className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#C9A646] text-[#C9A646] px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-[#C9A646]/10 transition-all duration-300 w-full sm:w-auto">
              <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
              Richiedi Preventivo
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
